// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"86dfda93","453":"156209b1","455":"bd073c5f","977":"760add3a"}[chunkId] + ".chunk.js";
};